import { render } from "./EmojiConfetti.vue?vue&type=template&id=cfde48d0"
import script from "./EmojiConfetti.vue?vue&type=script&lang=js"
export * from "./EmojiConfetti.vue?vue&type=script&lang=js"

import "./EmojiConfetti.vue?vue&type=style&index=0&id=cfde48d0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__